import { localeDetails } from '~/components/CmsMain/localeGlobals';

import { COUNTRY_TO_STATE_MAP } from '../../Types';

export function isTinRequired(organizationContactRolesDict, contactRole, contactCountry) {
  const effectiveCountry = contactCountry || localeDetails.locale.region;

  return effectiveCountry === 'US' && contactRole && !!organizationContactRolesDict[contactRole]?.is_tin_required;
}

export function isVatEnabled(contactCountry) {
  return contactCountry && contactCountry !== 'US';
}

export function displayRoleName(organizationContactRolesDict, role) {
  if (!role) {
    return '';
  }
  return organizationContactRolesDict[role].desc;
}

export function getAllClaimRelatedRoles(organizationContactRolesDict) {
  const dict = organizationContactRolesDict ?? {};
  return Object.keys(dict).filter((role) => !dict[role]?.is_multi_claim);
}

export function getAllOrganizationWideRoles(organizationContactRolesDict) {
  const dict = organizationContactRolesDict ?? {};
  return Object.keys(dict).filter((role) => dict[role]?.is_multi_claim && !dict[role]?.is_system);
}

export function getAllOrganizationRolesExcludingSystem(organizationContactRolesDict) {
  const dict = organizationContactRolesDict ?? {};
  return Object.keys(dict).filter((role) => !dict[role]?.is_system);
}

export function getAllSearchableContactRoles(organizationContactRolesDict) {
  const dict = organizationContactRolesDict ?? {};
  return Object.keys(dict).filter((role) => role !== 'user');
}

export function filterEnabledContactRoles(organizationContactRolesDict, roles) {
  const dict = organizationContactRolesDict ?? {};
  return (roles ?? []).filter((role) => dict[role]?.is_enabled !== false);
}

export function getRoleDescription(contact, organizationContactRolesDict) {
  const attorney_registration_name = localeDetails.locale.region === 'GB' ? 'SRA' : 'Bar';

  const contactRole = organizationContactRolesDict[contact.role];
  let contactRoleDesc = contactRole.desc;
  if (contact.role === 'other' && contact.role_other_desc) {
    contactRoleDesc += ` - ${contact.role_other_desc}`;
  }

  if (contact.attorney_bar_state) {
    contactRoleDesc += ` - ${COUNTRY_TO_STATE_MAP['US'][contact.attorney_bar_state]} Bar`;
  }

  if (contact.attorney_bar_number) {
    contactRoleDesc += `${contact.attorney_bar_state ? ',' : ` ${attorney_registration_name}`} #${
      contact.attorney_bar_number
    }`;
  }

  return contactRoleDesc;
}
